import { create } from "zustand";
import GetActiveAdminMessage from "../api-layer/admin-message-api/GetActiveAdminMessage";
import PatchAdminMessage from "../api-layer/admin-message-api/PatchAdminMessage";
import PostAdminMessage from "../api-layer/admin-message-api/PostAdminMessage";
import PutAdminMessage from "../api-layer/admin-message-api/PutAdminMessage";
import DeleteAdminMessage from "../api-layer/admin-message-api/DeleteAdminMessage";

export const useManagerMessageStore = create((set, get) => ({
  messages: [],
  initialized: false,
  loading: false,

  setMessages: (messages) => set({ messages }),

  initAdminMessages: async () => {
    if (get().loading || get().initialized) return;
    set({ loading: true });

    try {
      const response = await GetActiveAdminMessage("all");
      set({
        messages: response.data,
        initialized: true,
        loading: false,
      });
    } catch (e) {
      set({ loading: false });
    }
  },

  createMessage: async (message) => {
    const formData = new FormData();
    formData.append("message", message);

    return PostAdminMessage(formData);
  },

  updateMessage: async (code, message) => {
    const formData = new FormData();
    formData.append("message", message);

    return PutAdminMessage(code, formData);
  },


  deleteMessage: async (code) => {
    return DeleteAdminMessage(code);
  },

  changeActiveness: async (message) => {
    try {
      const formData = new FormData();
      formData.append("isActive", !message.isActive);

      await PatchAdminMessage(message.code, formData);

      // 🔥 update local state optimistically
      set((state) => ({
        messages: state.messages.map((m) =>
          m.id === message.id
            ? { ...m, isActive: !m.isActive }
            : m
        ),
      }));
    } catch (error) {
      // console.error("Failed to change activeness", error);
    }
  },

  upsertMessage: (message) =>
    set((state) => {
      const map = new Map(state.messages.map(m => [m.id, m]));
      map.set(message.id, message);

      return { messages: Array.from(map.values()) };
    }),

  upsertMessages: (incoming = []) => {
    set((state) => {
      const map = new Map(state.messages.map(m => [m.id, m]));
      incoming.forEach(msg => map.set(msg.id, msg));

      return { messages: Array.from(map.values()) };
    })
  },

  removeMessage: (id) =>
    set((state) => ({
      messages: state.messages.filter(m => m.id !== id),
    })),

  getActiveMessages: () =>
    get().messages.filter(m => m.isActive),
}));